export default __webpack_public_path__ + "static/media/App_ui.7db9db5e.png";